var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.418 9.4215C17.418 9.03739 17.418 8.84539 17.4757 8.67428C17.6437 8.17699 18.0866 7.98402 18.5303 7.78193C19.0291 7.55475 19.2784 7.44116 19.5255 7.42117C19.8061 7.39848 20.0871 7.45893 20.3269 7.59349C20.6447 7.77188 20.8664 8.11087 21.0934 8.38653C22.1416 9.65962 22.6656 10.2963 22.8574 10.9983C23.0122 11.5647 23.0122 12.1572 22.8574 12.7236C22.5777 13.7475 21.6941 14.6058 21.04 15.4003C20.7054 15.8066 20.5381 16.0098 20.3269 16.1284C20.0871 16.2629 19.8061 16.3234 19.5255 16.3007C19.2784 16.2807 19.0291 16.1672 18.5303 15.9399C18.0866 15.7378 17.6437 15.5449 17.4757 15.0476C17.418 14.8765 17.418 14.6845 17.418 14.3004V9.4215Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30556 9.42162C6.30556 8.93806 6.29198 8.50341 5.90101 8.1634C5.75881 8.03973 5.57028 7.95385 5.19323 7.78212C4.69446 7.55493 4.44507 7.44134 4.19796 7.42135C3.45657 7.3614 3.05769 7.86741 2.63014 8.38671C1.58194 9.65984 1.05784 10.2964 0.866067 10.9984C0.711311 11.565 0.711311 12.1574 0.866067 12.7238C1.14578 13.7477 2.02947 14.606 2.68357 15.4005C3.09588 15.9013 3.48974 16.3582 4.19796 16.301C4.44507 16.281 4.69446 16.1673 5.19323 15.9402C5.57028 15.7684 5.75881 15.6825 5.90101 15.5588C6.29198 15.2188 6.30556 14.7843 6.30556 14.3006V9.42162Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08203 7.41667C4.08203 3.73477 7.56426 0.75 11.8598 0.75C16.1554 0.75 19.6376 3.73477 19.6376 7.41667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6393 16.3057V17.1946C19.6393 19.1582 17.6494 20.7501 15.1949 20.7501H12.9727",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/ContactUs.5b3900e704b432831b55540ada771633.svg";
export { ForwardRef as ReactComponent };